// extracted by mini-css-extract-plugin
export default {"customMark":"Timeline_customMark__B73Kf","timeline":"Timeline_timeline__TqT46"};